import Patterns from '@hc-frontend/shared-assets/src/js/utils/validators/patterns';

function email(value) {
  const cleanValue = value.trim();

  return Patterns.email.test(cleanValue);
}

export default email;
